const LOCATIONS_AVAILABLE_HOTKEYS = {
  S: {
    hotkey: 's',
    description: 'Curation / QA / QC done the selected location',
  },
  SHIFT_S: {
    hotkey: 'shift+s',
    description: 'Curation / QA / QC done all locations from current page',
  },
  ENTER: {
    hotkey: 'enter',
    description: 'Start editing the selected cell',
  },
  ESC: {
    hotkey: 'esc',
    description: 'Stop/Save editing of the selected cell',
  },
  R: {
    hotkey: 'r',
    description: 'Mark the location for batch operation',
  },
  SHIFT_R: {
    hotkey: 'shift+r',
    description: 'Mark all locations for batch operation',
  },
}

export default LOCATIONS_AVAILABLE_HOTKEYS
